import { Key, useEffect } from 'react'

import { useToggle } from '@app/hooks'

import { MONITORING_TASK_STATUS } from '@app/api/constants'

import type { UseToggleToolbarButtonsReturn } from './types'
import type { MonitoringRegistryDataSource } from '@app/pages/MonitoringRegistryPage/types'

export const useToggleToolbarButtons = (
  selectedKeys: Key[],
  selectedRecords: MonitoringRegistryDataSource[]
): UseToggleToolbarButtonsReturn => {
  const stopButtonToggle = useToggle()
  const recoveryButtonToggle = useToggle()
  const restartButtonToggle = useToggle()

  const handleUnselectToolbarSelectedButtons = (): void => {
    stopButtonToggle.setUntoggled()
    recoveryButtonToggle.setUntoggled()
    restartButtonToggle.setUntoggled()
  }

  const handleToggleButtons = (): void => {
    const selectedCount = selectedKeys.length
    const selectedOne = selectedCount === 1
    const selectedMoreThanOne = selectedCount > 1
    const selectedStatuses = selectedRecords.map(record => record.status)
    const selectedHasStopped = selectedStatuses.includes(MONITORING_TASK_STATUS.STOPPED)
    const selectedOnlyStopped = selectedStatuses.every(status => status === MONITORING_TASK_STATUS.STOPPED)
    const selectedHasStart = selectedStatuses.includes(MONITORING_TASK_STATUS.START)
    const selectedOnlyStart = selectedStatuses.every(status => status === MONITORING_TASK_STATUS.START)

    if (!selectedCount) {
      handleUnselectToolbarSelectedButtons()
      return
    }

    // Включение/отключение кнопки Перезапустить
    if (selectedOne && !selectedHasStart) {
      restartButtonToggle.setToggled()
    }

    if (selectedMoreThanOne && !selectedOnlyStart) {
      restartButtonToggle.setToggled()
    }

    if (selectedMoreThanOne && selectedOnlyStart) {
      restartButtonToggle.setUntoggled()
    }
    // END Включение/отключение кнопки Перезапустить

    // Включение/отключение кнопок Остановить и Восстановить
    if (selectedOne && selectedHasStopped) {
      recoveryButtonToggle.setToggled()
      stopButtonToggle.setUntoggled()
      return
    }

    if (selectedOne && !selectedHasStopped) {
      stopButtonToggle.setToggled()
      recoveryButtonToggle.setUntoggled()
      return
    }

    if (selectedMoreThanOne && selectedOnlyStopped) {
      recoveryButtonToggle.setToggled()
      stopButtonToggle.setUntoggled()
      return
    }

    if (selectedMoreThanOne && selectedHasStopped) {
      recoveryButtonToggle.setToggled()
      stopButtonToggle.setToggled()
      return
    }

    if (selectedMoreThanOne && !selectedOnlyStopped) {
      stopButtonToggle.setToggled()
      recoveryButtonToggle.setUntoggled()
    }
    // END Включение/отключение кнопок Остановить и Восстановить
  }

  useEffect(() => {
    handleToggleButtons()
  }, [selectedKeys])

  return {
    stopButtonToggle,
    restartButtonToggle,
    recoveryButtonToggle,
    handleUnselectToolbarSelectedButtons
  }
}
